import { Engine1Proxy, RestApiProxy, SagasProxy } from 'com-gyf-webcore-servicehub';

let PerfilManager = function () {
    /**
     * 
     * @param {any} data
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function _guardarConfiguracion(data, sagasCallback, viewCallback) {
        let localValues = mapearConfiguracion(data);
        ejecutarSagas(localValues, 'SAGA_EDITAR_CONFIGURACION', sagasCallback, viewCallback);
    }

    /**
     * 
     * @param {any} data
     */
    function mapearConfiguracion(data) {
        
        let localValues = {
            "CONF_PASSWORD_SESION": {
                'ID': data.ID,
                'ALFABETICA': data.ALFABETICA,
                'NUMERICA': data.NUMERICA,
                'CARACTERES_ESPECIALES': data.CARACTERES_ESPECIALES,
                'PERMITE_NROS_CONSECUTIVOS': data.PERMITE_NROS_CONSECUTIVOS,
                'PERMITE_LETRAS_CONSECUTIVAS': data.PERMITE_LETRAS_CONSECUTIVAS,
                'PERMITE_REPETIR_POSICION': data.PERMITE_REPETIR_POSICION,
                'PERMITE_CARACTERES_IGUALES': data.PERMITE_CARACTERES_IGUALES,
                'CASE_SENSITIVE': data.CASE_SENSITIVE,
                'CARACTERES_MINIMOS': data.CARACTERES_MINIMOS,
                'CANTIDAD_REPETICIONES': data.CANTIDAD_REPETICIONES, 
                'MAX_DIAS_INACTIVIDAD': data.MAX_DIAS_INACTIVIDAD,
                'MAX_DIAS_CADUCIDAD': data.MAX_DIAS_CADUCIDAD,
                'MINUTOS_PERMITIDOS_INACTIVIDAD': data.MINUTOS_PERMITIDOS_INACTIVIDAD,
                'CANT_INTENTOS_FALLIDOS': data.CANT_INTENTOS_FALLIDOS
            },
            "CONF_PASSWORD_TYPE": {
                'ID': data.ID_CONF_PASSWORD_TYPE,
                'ALTA_AUTOMATICA': data.ALTA_AUTOMATICA,
                'VINCULAR_GRUPO_WINDOWS': data.VINCULAR_GRUPO_WINDOWS,
                'SOLICITAR_CONTRASENIA': data.SOLICITAR_CONTRASENIA,
                'SOLO_USUARIO_LOGGEADO': data.SOLO_USUARIO_LOGGEADO,
                'TIPO_SEGURIDAD': data.TIPO_SEGURIDAD == 1 ? "GYF" : "AD"
            },
            "PLATAFORMAS": data.PLATAFORMAS
        }

        return localValues;
    }

    /**
     * 
     * @param {any} localValues
     * @param {any} saga
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function ejecutarSagas(localValues, saga, sagasCallback, viewCallback) {
        SagasProxy.AddSagaRequests(localValues, saga, "CONCIERGE", "SEGURIDAD");

        RestApiProxy.SetApiUrl();

        SagasProxy.Execute(sagasCallback, undefined, viewCallback, null, null, "SEGURIDAD");
    }

    return {
        GuardarConfiguracion: function (data, sagasCallback, viewCallback) {
            return _guardarConfiguracion(data, sagasCallback, viewCallback);
        }
    }
};

let perfilManager = new PerfilManager();
export default perfilManager;